import { API_INTRANET, API_USER_ADMIN } from '../constants/api';
import request from './api';

export const getNewById = id => {
  const params = new URLSearchParams(window.location.search);
  const fromCms = params.get('fromCms') === 'true';

  return request(`${API_INTRANET}news/${id}?fromCms=${fromCms}`);
};

export const getAllNewsPage = params =>
  request(`${API_INTRANET}contentPage/${params.position}`, {
    params,
    method: 'GET'
  });

export const makeDraw = (newID, items, like, comment, notificationUser) =>
  request(`${API_USER_ADMIN}users/getUsersWithGiveaways/${newID}`, {
    method: 'POST',
    params: {
      like,
      comment,
      notificationUser
    },
    data: {
      prizes: items
    }
  });

export const getUsersThatLikedOrCommented = newID =>
  request(`${API_USER_ADMIN}users/getUsersThatLikedOrCommented/${newID}`, {
    method: 'GET'
  });
